import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo.js';
import { Exam } from '../exam.js';

export const getExamsByClassQuery = registerQuery({
  operationName: 'getExamsByClassQuery',
  type: () => [Exam],
  params: [{ name: 'className', type: () => String }],

  resolve:
    (className: string) =>
    async (_gqlFields: BaseQLSelectionSet<Exam>): Promise<Exam[]> => {
      const trimmedClass = typeof className === 'string' ? className.trim() : '';
      if (!trimmedClass) return [];

      const currentUser = await CurrentUserInfo.getMyself()({ _id: 1 });
      if (!currentUser?._id) return [];

      const examCollection = await getCollection(Exam);
      const exams = await examCollection
        .find({ userID: currentUser._id, class: trimmedClass })
        .sort({ createdAt: -1 })
        .toArray();

      return exams as Exam[];
    },
});
